import { render, staticRenderFns } from "./MdtWizardContent.vue?vue&type=template&id=77c45d56&scoped=true"
import script from "./MdtWizardContent.vue?vue&type=script&lang=js"
export * from "./MdtWizardContent.vue?vue&type=script&lang=js"
import style0 from "./MdtWizardContent.vue?vue&type=style&index=0&id=77c45d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c45d56",
  null
  
)

export default component.exports